module.exports = __webpack_public_path__ + "static/txn_phone_d-79749ad56a6250d88aaa0fdfc9a008e3.webp";